import { ScanOrScanTemplatePartTypeSchema } from '../CommonScanSchemas';

export type IdsByDepth = (string | undefined)[];

export const SCAN_PART_DEPTH = {
  scan: 0,
  group: 1,
  task: 2,
  option: 3,
  lineItem: 4,
};
export const SCAN_CHILDREN_FIELD_NAMES_BY_DEPTH = ['groups', 'tasks', 'options', 'lineItems'] as const;
export const SCAN_CHILDREN_BY_ID_FIELD_NAMES_BY_DEPTH = ['groupsById', 'tasksById', 'optionsById', 'lineItemsById'] as const;
export const SCAN_PART_TYPES_BY_DEPTH: ScanOrScanTemplatePartTypeSchema[] = ['scan', 'group', 'task', 'option', 'lineItem'] as const;
export const MAX_SCAN_DATA_STRUCTURE_RECURSION_DEPTH = 4; // 0, 1, 2 and 3 are valid, 4+ is not
export const validateScanDataStructureRecursionDepth = (recursionDepth: number) => {
  if (recursionDepth > MAX_SCAN_DATA_STRUCTURE_RECURSION_DEPTH) {
    throw new Error(
      `Exceeded Scan Data Structure Recursion Limit: Recursion depth ${recursionDepth} is greater than the maximum allowed depth ${MAX_SCAN_DATA_STRUCTURE_RECURSION_DEPTH}`,
    );
  }
};

export const getScanChildrenFieldName = (recursionDepth: number): string => {
  validateScanDataStructureRecursionDepth(recursionDepth);
  return SCAN_CHILDREN_FIELD_NAMES_BY_DEPTH[recursionDepth];
};

export const getIdsByDepth = (
  groupId?: string,
  taskId?: string,
  optionId?: string,
  lineItemId?: string,
): IdsByDepth => [undefined, groupId, taskId, optionId, lineItemId];
